const getDay = (date) => {
    const day = new Date(date).getDay()

    switch (day) {
        case 0:
            return "Sun"
        case 1:
            return "Mon"
        case 2:
            return "Tues"
        case 3:
            return "Wed"
        case 4:
            return "Thurs"
        case 5:
            return "Fri"
        case 6:
            return "Sat"
        default:
            break;

    }
}
const getDate = (date) => {
    const dayNum = new Date(date)
    return dayNum.getDate()

}

const getMonth = (date) => {
    const month = new Date(date).getMonth()

    return month + 1
}


const Day = ({ date }) => {
    return (
        <>
            {/* Fri, 01/22 */}
            {`${getDay(date)}, ${getMonth(date)}/${getDate(date)}`}
        </>
    );
}

export default Day;